/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import Space from 'material/space/space';
import { Control } from '@insticator/insticator-ui';
import { SectionGroupV2 } from 'material/expandablesection/v2'
// styles
import injectSheet from 'react-jss'
import styles from './moderationtype_styles'


/* ========== ~~~~~~~~~~ MODERATION CONFIG: GENERAL SECTION : MODERATION TYPE ~~~~~~~~~~ ========== */
const ModerationType = injectSheet(styles)((props) => {

  const { moderationType, onChange } = props

  const handleModerationTypeChange = (value) => {
    onChange?.(value)
  }

  return (
    <SectionGroupV2 klass={`moderationtype ${props.classes.moderationtype}`} title={'Moderation type'} rowGap={32} direction={'column'}>
      <Space direction={'column'}>
        <Control
          text={'Post Moderation'} 
          value={'POST_MODERATION'} 
          handleSelect={() => handleModerationTypeChange('POST_MODERATION')} 
          variant={'system'}  
          addCheckWhenSelected={true} 
          selected={moderationType === 'POST_MODERATION'} 
        />
        <p>
          Comments will first go through the profanity filter. If they pass that filter, they will be posted and seen by the entire community. 
          AI Moderation (if selected) and then human moderation (if necessary) will occur after it is posted at which time it will be Accepted 
          and remain or Rejected and removed.
        </p>
      </Space>
      <Space direction={'column'}>
        <Control
          text={'Pre Moderation'} 
          value={'PRE_MODERATION'} 
          handleSelect={value => handleModerationTypeChange(value)} 
          variant={'system'}  
          addCheckWhenSelected={true} 
          selected={moderationType === 'PRE_MODERATION'} 
        />
        <p>
          Comments will first go through the profanity filter. If they pass that filter, they will be posted and seen by ONLY the commenter. 
          AI Moderation (if selected) and then human moderation (if necessary) will occur after it is posted at which time it will be Accepted or Rejected.
          If Accepted, the entire community will now be able to see the comment.
        </p>
      </Space>
      <Space direction={'column'}>
        <Control
          text={'No Moderation'} 
          value={'NO_MODERATION'} 
          handleSelect={value => handleModerationTypeChange(value)} 
          variant={'system'}  
          addCheckWhenSelected={true} 
          selected={moderationType === 'NO_MODERATION'} 
        />
        <p>
          No moderation will be done for any comment and all comments will immediately be available within the community.
        </p>
      </Space>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ModerationType;